import * as yup from 'yup';

export const validationProfileSchema = yup.object().shape({
  email: yup.string().email('Entered value does not match email format.'),
  userName: yup.string(),
});
